import { useEffect, useState } from "react";
import { usePreviousValue } from "@picklebet/ui";

export type OddsDirection = "up" | "down";

export const useOddsDirection = (
  odds: number,
  initialOdds?: number,
  animationLength: number | null = 3000,
  override?: OddsDirection,
) => {
  const previousOdds = usePreviousValue(odds);
  const [direction, setDirection] = useState<OddsDirection | undefined>(
    override,
  );

  useEffect(() => {
    if (initialOdds !== undefined && odds !== initialOdds) {
      setDirection(odds < initialOdds ? "down" : "up");
    } else if (previousOdds !== null && previousOdds !== odds) {
      setDirection(previousOdds < odds ? "up" : "down");
    } else {
      setDirection(undefined);
    }

    if (animationLength === null) return;

    const timeout = setTimeout(() => setDirection(undefined), animationLength);
    return () => clearTimeout(timeout);
  }, [odds, initialOdds, animationLength]);

  return direction;
};
